var _effectorFileName = "/builds/gmini/front-utils/src/queryParser.ts";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.is-array.js";
import qs from 'query-string';
export function queryParser(_ref) {
  var key = _ref.key,
      options = _ref.options;
  var queryStringObject = qs.parse(window.location.search, options);

  if (queryStringObject === null) {
    return undefined;
  }

  if (!key) {
    return queryStringObject;
  }

  var value = queryStringObject[key];

  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'number') {
    return value;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'string') {
    return value[0];
  }

  return undefined;
}